/*
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2023-09-07 18:11:49
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-08-14 15:24:45
 * @FilePath: \front\src\views\mixin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const mixin = {
	data() {
		return {
			my: undefined,
			isLoading: false,
			isAllSelection: false,
			pageTitle: '',
			multipleSelection: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
			patientRelationship:[
				{ label: "患者本人", value: 0 },
				{ label: "配偶", value: 1 },
				{ label: "子", value: 2 },
				{ label: "女", value: 3 },
				{ label: "孙子孙女", value: 4 },
				{ label: "父母", value: 5 },
				{ label: "祖父母", value: 6 },
				{ label: "兄弟姐妹", value: 7 },
				{ label: "其他亲属", value: 8 },
				{ label: "兄弟姐妹（堂）", value: 9 },
			],
			dataSourceList:[
				{ label: "住院", value: 0 },
				{ label: "门诊", value: 1 },
				{ label: "出院", value: 2 }
			],
			phoneRelationship:{
				0: '(患者本人)',
				1: '(配偶)',
				2: '(子)',
				3: '(女)',
				4: '(孙子孙女)',
				5: '(父母)',
				6: '(祖父母)',
				7: '(兄弟姐妹)',
				8: '(其他亲属)',
				9: '(兄弟姐妹（堂）)'
			},
			dataSourceObj:{0:'住院',1:"门诊",2:'出院',3:'手动添加'},
			manualState:[
				{
					value: '0',
					label: '待提醒',
				},
				{
					value: '1',
					label: '电话已提醒',
				},
				{
					value: '2',
					label: '短信已提醒',
				},
				{
					value: '3',
					label: '短信电话已提醒',
				}
			],
			smsAutoState:[
				{
					value: '0',
					label: '待提醒',
				},
				{
					value: '1',
					label: '已提醒',
				},
				{
					value: '2',
					label: '未提醒（余额不足）',
				},
				{
					value: '3',
					label: '未提醒（自动发送未开启）',
				},
				{
					value: '4',
					label: '发送失败',
				},
			]
		}
	},
	created() {
		// this.my = this.getUser();
		// this.permission = this.$store.state.permission['http://jiankong.hanlincloud.com/alarm'];
		if (!this.noSidebar) {
			this.$parent.$parent.$parent.$parent.updateSidebar();	
		}
		this.my = JSON.parse(localStorage.getItem('user')).data;
	},	
	methods: {
		// 全选 / 取消全选
		toggleSelection() {
			if (this.isAllSelection) {
				this.$refs.multipleTable.clearSelection();
				this.list.data.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		selectionChange(selected) {
			let selection = []
			selected.forEach((item)=>{
				selection.push(item.id);
			})
			this.multipleSelection = selection;
		},
		clearSelection() {
			this.$refs.multipleTable.clearSelection();
		},
		goBack() {
			history.back();
		},
		deepClone(obj) {
			var newobj = obj.constructor === Array ? [] : {};
			if(typeof obj !== 'object'){
				return;
			}
			for(var i in obj){
				newobj[i] = (typeof obj[i] === 'object' && obj[i] !== null) ? this.deepClone(obj[i]) : obj[i];
			}
			return newobj;
		}
	}
};

export default mixin